import React, { useState } from "react";
import Icon, { FormOutlined } from "@ant-design/icons";
import { Form, Space } from "antd";
import { ColumnsType } from "antd/lib/table";
import { ReactComponent as iconGroup } from "assets/groupIcon.svg";
import { ReactComponent as forumIcon } from "assets/forumIcon.svg";
import { DataCourse, statusTypes } from "types";
import "react-quill/dist/quill.snow.css";
import "./style.scss";
import {
	AddCourseModal,
	AddStudentInCourseModal,
	EditCourseModal,
	ViemForumModal,
	MenuPage
} from "components";
// import { dataCourse } from "utils/mocks";
import { useNavigate } from "react-router-dom";
import { api } from "services/api";

export const ManageCourses: React.FC = () => {
	const [refreshTable, setRefreshTable] = useState<boolean>(false);
	const [isOpen, setIsOpen] = useState<boolean>(false);
	const [isOpenEdit, setIsOpenEdit] = useState<boolean>(false);
	const [isOpenNewStudentModal, setIsOpenNewStudentModal] =
		useState<boolean>(false);
	const [isOpenForum, setIsOpenForum] = useState<boolean>(false);
	const [currentImgURL, setCurrentImgURL] = useState<string>("");
	const [courseStatus, setCourseStatus] = useState<boolean>(false);
	const [currentCourseData, setCurrentCourseData] = useState<DataCourse>();
	const navigate = useNavigate();
	const [form] = Form.useForm();
	const [addStudentForm] = Form.useForm();

	const [editForm] = Form.useForm();

	const getUpdatedInfo = async (id: string) => {
		const {
			data: {
				data: { course },
			},
		} = await api.get(`/courses/${id}`);

		setCurrentCourseData(course);
	};

	const columns: ColumnsType<DataCourse> = [
		{
			title: "Nome",
			dataIndex: "title",
			key: "title",
			render: (text) => <p style={{ margin: 0 }}>{text}</p>,
			onCell: (data) => {
				return {
					onClick: (e) =>
						navigate(`${window.location.pathname}/course/${data.id}`, {
							state: {
								data,
							},
						}),
					style: { cursor: "pointer" },
				};
			},
		},
		{
			title: "Cadastrado em",
			dataIndex: "created_at",
			key: "created_at",
			render: (text) => <p style={{ margin: 0 }}>{text ? text : "-"}</p>,
			onCell: (data) => {
				return {
					onClick: (e) =>
						navigate(`${window.location.pathname}/course/${data.id}`, {
							state: {
								data,
							},
						}),
					style: { cursor: "pointer" },
				};
			},
		},
		{
			title: "Última edição",
			dataIndex: "updated_at",
			key: "updated_at",
			render: (text) => <p style={{ margin: 0 }}>{text ? text : "-"}</p>,
			onCell: (data) => {
				return {
					onClick: (e) =>
						navigate(`${window.location.pathname}/course/${data.id}`, {
							state: {
								data,
							},
						}),
					style: { cursor: "pointer" },
				};
			},
		},
		{
			title: "Status",
			dataIndex: "status",
			key: "status",
			render: (text) => <p style={{ margin: 0 }}>{statusTypes[text]}</p>,
			onCell: (data) => {
				return {
					onClick: (e) =>
						navigate(`${window.location.pathname}/course/${data.id}`, {
							state: {
								data,
							},
						}),
					style: { cursor: "pointer" },
				};
			},
		},
		{
			title: "Ativo",
			dataIndex: "is_active",
			key: "is_active",
			render: (active) => (
				<p style={{ margin: 0 }}>{active === true ? "Sim" : "Não"}</p>
			),
		},
		{
			title: "",
			key: "action",
			render: (_, record) => (
				<Space size="middle" style={{ cursor: "initial" }}>
					<FormOutlined
						className="edit"
						onClick={async () => {
							await getUpdatedInfo(`${record?.id}`);
							setIsOpenEdit(true);
						}}
					/>
					<Icon
						component={iconGroup}
						className="group"
						style={{ fontSize: "28px" }}
						onClick={() => {
							setIsOpenNewStudentModal(true);
							setCurrentCourseData(record);
						}}
					/>
					<Icon
						component={forumIcon}
						style={{ fontSize: "28px" }}
						className="group"
						onClick={() => {
							setIsOpenForum(true);
							setCurrentCourseData(record);
						}}
					/>
				</Space>
			),
		},
	];

	const handleClickAdd = () => { setIsOpen(true)}
	const handleRefresh = () => {
		setRefreshTable(true);
		setTimeout(() => {
		  	setRefreshTable(false);
		}, 1000);
	};
	const getTableDataFromResponse = (responseData: any) => {
		return responseData.data.courses;
	}

	return (
		<div className="m-courses">
			<AddCourseModal
				form={form}
				isOpen={isOpen}
				setIsOpen={setIsOpen}
				currentImgURL={currentImgURL}
				setCurrentImgURL={setCurrentImgURL}
				onCreated={handleRefresh}
			/>

			<AddStudentInCourseModal
				form={addStudentForm}
				isOpen={isOpenNewStudentModal}
				setIsOpen={setIsOpenNewStudentModal}
				currentImgURL={currentImgURL}
				setCurrentImgURL={setCurrentImgURL}
				courseStatus={courseStatus}
				setCourseStatus={setCourseStatus}
				currentCourseData={currentCourseData as DataCourse}
			/>

			<EditCourseModal
				form={editForm}
				isOpen={isOpenEdit}
				currentImgURL={currentImgURL}
				setCurrentImgURL={setCurrentImgURL}
				setIsOpen={setIsOpenEdit}
				currentCourseData={currentCourseData}
				onUpdated={handleRefresh}
			/>

			<ViemForumModal
				setIsOpen={setIsOpenForum}
				isOpen={isOpenForum}
				currentCourseData={currentCourseData}
				isCourse={true}
			/>

			<MenuPage 
				title="Cursos" 
				tableColumns={columns} 
				sourceDataUrl={'/courses'}  
				getDataFromResponse={getTableDataFromResponse} 
				addButtonText="+ Adicionar Curso" 
				onClickAdd={handleClickAdd} 
				refreshData={refreshTable}
				searchPlaceholder="Busque por nome"
			/>
		</div>
	);
};
